import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_115: FaireProductEntity = {
  token: "starter_collection_115",
  type: "product",
  name: "Canyon Coffee X JB Blunk",
  brandName: "Canyon Coffee",
  imageUrl:
    '"https://cdn.faire.com/fastly/96aba71f88fd1bc1516470108c94f8082f21c21bfd0fe7436cccc2b091a52266.png?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=863',
  priceDollars: 45,
  msrpDollars: 90,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
